import React from 'react';
import type ProductsJsmComplianceType from '@atlassian/jira-spa-apps-products-jsm-compliance/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProductsJsmCompliance = lazyForPaint<typeof ProductsJsmComplianceType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-products-jsm-compliance", jiraSpaEntry: "async-products-jsm-compliance" */ '@atlassian/jira-spa-apps-products-jsm-compliance'
		),
	),
);

const AsyncProductsJsmCompliance = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProductsJsmCompliance}
		pageId="products-jsm-compliance"
		shouldShowSpinner={false}
	/>
);

export default AsyncProductsJsmCompliance;
